/*
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-13 21:25:41
 * @LastEditTime: 2026-04-14 14:12:24
 * @LastEditors: ranli
 */
import { createApp, h } from 'vue'
import ConfirmComponent from './index.vue'

let instance = null

/**
 * 函数式调用 Confirm 确认弹窗
 * @param {object|string} options - 配置对象或消息字符串
 * @param {string} options.message - 确认内容文案
 * @param {string} [options.title] - 标题
 * @param {string} [options.icon] - Vant 图标名称
 * @param {string} [options.iconSize='48px'] - 图标大小
 * @param {string} [options.iconColor='#ee0a24'] - 图标颜色
 * @param {boolean} [options.showClose=false] - 显示右上角关闭按钮
 * @param {boolean} [options.showCancelButton=true] - 显示取消按钮
 * @param {string} [options.cancelText='Cancel'] - 取消按钮文案
 * @param {string} [options.confirmText='Confirm'] - 确认按钮文案
 * @param {string} [options.subtitle] - 子标题内容文案
 * @param {boolean} [options.closeOnClickOverlay=false] - 点击遮罩关闭
 * @param {Function} [options.messageRender] - 自定义 message 区域的渲染函数（支持 JSX）
 * @param {Function} [options.footerRender] - 自定义 footer 区域的渲染函数（支持 JSX）
 * @returns {Promise<boolean>} confirm 返回 true，cancel 返回 false
 */
export function showConfirm(options) {
  const opts = typeof options === 'string' ? { message: options } : options

  return new Promise((resolve) => {
    if (instance) {
      instance.unmount()
      if (instance._container && instance._container.parentNode) {
        document.body.removeChild(instance._container)
      }
      instance = null
    }

    const container = document.createElement('div')
    document.body.appendChild(container)

    const app = createApp({
      setup() {
        const visible = ref(true)

        const onConfirm = () => {
          visible.value = false
          cleanup()
          opts.onConfirm?.()
          resolve(true)
        }

        const onCancel = () => {
          visible.value = false
          cleanup()
          opts.onCancel?.()
          resolve(false)
        }

        const onClose = () => {
          visible.value = false
          cleanup()
          opts.onClose?.()
          resolve(false)
        }

        const cleanup = () => {
          setTimeout(() => {
            app.unmount()
            if (container.parentNode) {
              document.body.removeChild(container)
            }
            instance = null
          }, 300)
        }

        return () =>
          h(ConfirmComponent, {
            modelValue: visible.value,
            'onUpdate:modelValue': (val) => {
              visible.value = val
            },
            message: opts.message || '',
            title: opts.title || '',
            subtitle: opts.subtitle || '',
            icon: opts.icon || '',
            iconSize: opts.iconSize || '48px',
            iconColor: opts.iconColor || '#ee0a24',
            showClose: opts.showClose ?? false,
            showCancelButton: opts.showCancelButton ?? true,
            cancelText: opts.cancelText || 'Cancel',
            confirmText: opts.confirmText || 'Confirm',
            closeOnClickOverlay: opts.closeOnClickOverlay ?? false,
            teleport: '',
            onConfirm,
            onCancel,
            onClose,
          }, {
            message: opts.messageRender
              ? () => opts.messageRender()
              : undefined,
            footer: opts.footerRender
              ? () => opts.footerRender()
              : undefined,
          })
      },
    })

    instance = app
    instance._container = container
    app.mount(container)
  })
}
